import { Achievement } from '../../types';
import { ui } from '../../data/ui';
import { ScrollReveal } from './ScrollReveal';
import './AchievementCard.css';

interface AchievementCardProps {
  achievement: Achievement;
  index: number;
}

export function AchievementCard({ achievement, index }: AchievementCardProps) {
  const isCompetition = achievement.type === 'competition';
  const isPlaceholder = (value: string) => value.startsWith('[');

  return (
    <ScrollReveal delay={index * 0.1}>
      <div className={`achievement-card glass-card ${isCompetition ? 'achievement-card-premium' : ''}`}>
        <div className="achievement-images">
          {achievement.images.map((img, i) => (
            <div key={i} className="achievement-image">
              {!isPlaceholder(img) ? (
                <img src={img} alt={`${achievement.name} ${i + 1}`} loading="lazy" />
              ) : (
                <div className="placeholder-image achievement-placeholder">
                  {ui.achievements.addImage} {i + 1}]
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="achievement-content">
          <div className="achievement-header">
            <span className="tag">{achievement.year}</span>
            {achievement.achievement && (
              <span className="achievement-badge">{achievement.achievement}</span>
            )}
          </div>
          <h3 className="achievement-name">{achievement.name}</h3>
          <p className="achievement-participation">{achievement.participation}</p>
          <p className="achievement-description">{achievement.description}</p>
          {achievement.teamInfo && !isPlaceholder(achievement.teamInfo) && (
            <p className="achievement-team">{achievement.teamInfo}</p>
          )}
          {achievement.externalUrl && !isPlaceholder(achievement.externalUrl) && (
            <a
              href={achievement.externalUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-ghost"
            >
              {ui.achievements.learnMore} <span className="arrow">←</span>
            </a>
          )}
        </div>
      </div>
    </ScrollReveal>
  );
}
